import BallFilterIcon from "../../assets/icons/filter-ball.svg";
import BallFilterActiveIcon from "../../assets/icons/filter-ball-active.svg";
import IconPlaneta from "../../assets/icons/filters/planeta.svg";
import IconZigzagAroow from "../../assets/icons/filters/icon-zigzag-arrow.svg";
import IconDollarQuadro from "../../assets/icons/filters/icon-dollar-quadro.svg";
import DollarFilterIcon from "../../assets/icons/filter-dollar.svg";
import IconFlowerDollar from "../../assets/icons/filters/flower.svg";
import IconStar from "../../assets/icons/filters/star.svg";
import IconAttantion from "../../assets/icons/filters/attention.svg";
import DollarFilterIconActive from "../../assets/icons/filter-dollar-active.svg";
import IconStarGray from "../../assets/icons/icon-star-gray.svg";
import IconStarActive from "../../assets/icons/icon-star-active.svg";
import SettingsIconActive from "../../assets/icons/alarm-settings-active.svg";
import FlagRuIconActive from "../../assets/icons/flag-ru-active.svg";
import LogoIconActive from "../../assets/icons/logo-small-active.svg";
import IconWeakSignal from "../../assets/icons/weak_signal.svg";
import IconWeakSignalActive from "../../assets/icons/weak_signal_active.svg";
import IconRussiaActive from "../../assets/icons/flag-ru-active.svg";
import IconWorld from "../../assets/icons/filter-ball-active.svg";
import {IFiltersTop} from "./types";
import {ITypeRadar} from "../../types";
import {IImpactArea} from "../../hooks/useFetchImpactAreas";
import {FEATURE_CLUSTER_BATTERY_METRIC_ENABLED} from "../../config/featureFlags";

export const LIFE_CYCLE_VALUES = [
  "Общественное обсуждение",
  "Пилот",
  "Масштабирование",
] as const;

export const LIFE_CYCLE_MOCK_DATA = LIFE_CYCLE_VALUES.map((value) => ({
  value,
  label: value,
}));

export let INFLUENCE_ZONE_MOCK_DATA: IImpactArea[] = [];

export const updateInfluenceZoneData = (newData: IImpactArea[]) => {
  INFLUENCE_ZONE_MOCK_DATA = newData;
};

export const OBLIGATION_MOCK_DATA = [
  {
    value: "Обязательно",
    label: "Обязательно",
  },
  {
    value: "Рекомендовано",
    label: "Рекомендовано",
  },
  {
    value: "Добровольно",
    label: "Добровольно",
  },
];
export const PARTICIPATION_FORMAT_MOCK_DATA = [
  {
    value: "Обязательный участник",
    label: "Обязательный участник",
  },
  {
    value: "Пилот",
    label: "Пилот",
  },
  {
    value: "Экспертные обсуждения",
    label: "Экспертные обсуждения",
  },
];

export const getFilterOptions = (filterId: string, typeRadar: ITypeRadar) => {
  const filters = FILTERS_ITEMS.get(typeRadar);
  const filter = filters?.find((f) => f.id === filterId);
  return filter?.selectOptions || [];
};

export const FILTERS_ITEMS: Map<ITypeRadar, IFiltersTop[]> = new Map([
  [
    "map",
    [
      {
        id: "battery_russia",
        type: "severalMaturity",
        countItems: 5,
        tooltip: "Зрелость технологии",
        icon: IconPlaneta,
        iconActive: BallFilterActiveIcon,
      },
      {
        id: "market_volume_tier",
        type: "several",
        countItems: 3,
        tooltip: "Прогноз мирового рынка 2030",
        icon: IconPlaneta,
        iconActive: BallFilterActiveIcon,
      },
      {
        id: "invest_volume_tier",
        type: "several",
        countItems: 3,
        tooltip: "Инвестиционная активность в мире",
        icon: IconFlowerDollar,
        iconActive: DollarFilterIconActive,
      },
      {
        id: "critical",
        type: "single",
        countItems: 0,
        tooltip: "Критические технологические кластеры",
        icon: IconAttantion,
        iconActive: SettingsIconActive,
      },
      {
        id: "national",
        type: "single",
        countItems: 0,
        tooltip: "Кластеры в составе нац. проектов РФ",
        icon: FlagRuIconActive,
        iconActive: FlagRuIconActive,
      },
      // {
      //   id: "gpb",
      //   type: "single",
      //   countItems: 0,
      //   tooltip: "Присутствие ГПБ",
      //   icon: LogoIconActive,
      //   iconActive: LogoIconActive,
      // },
    ],
  ],
  [
    "esg",
    [
      {
        // id: "cagr_tier",
        id: "parametr_esg",
        type: "select",
        selectOptions: [
          // {label: "Все", value: ""},
          {label: "Rank", value: "rank_tier"},
          {label: "CAGR", value: "cagr_tier"},
          {
            label: "Прогноз объема рынка",
            value: "global_market_forecast_2030_bln_usd",
          },
        ],
        countItems: 3,
        title: "Параметр фильтра",
        // tooltip: "Объем мирового рынка к 2030 г.",
        tooltip: "Объем мирового рынка к 2030 г.",
        icon: BallFilterIcon,
        iconActive: BallFilterActiveIcon,
      },
      {
        // id: "rank_tier",
        id: "value_esg",
        type: "select",
        selectOptions: [
          {label: "Топ 25", value: "top25"},
          {label: "Топ 50", value: "top50"},
          {label: "Топ 100", value: "top100"},
          {label: "Все", value: "all"},
        ],
        title: "Значения фильтра",
        countItems: 3,
        // tooltip: "Объем мирового рынка к 2030 г.",
        tooltip: "Объем мирового рынка к 2030 г.",
        icon: IconStarGray,
        iconActive: IconStarActive,
      },
      // {
      //   id: "market_forecast_tier",
      //   type: "several",
      //   countItems: 3,
      //   tooltip: "Объем мировых инвестиций 2023-2026 гг.",
      //   icon: DollarFilterIcon,
      //   iconActive: DollarFilterIconActive,
      // },
    ],
  ],
  [
    "fintech",
    [
      {
        id: "market_volume_tier",
        type: "several",
        countItems: 3,
        tooltip: "Объем мирового рынка 2026",
        icon: IconPlaneta,
        iconActive: DollarFilterIconActive,
      },
      {
        id: "market_volume_forecast_tier",
        type: "several",
        countItems: 3,
        tooltip: "Прогноз объема мирового рынка 2026",
        icon: IconFlowerDollar,
        iconActive: IconStarActive,
      },
      {
        id: "cagr_tier",
        type: "several",
        countItems: 3,
        tooltip: "CAGR, %",
        icon: IconZigzagAroow,
        iconActive: LogoIconActive,
      },
      {
        id: "venture_invest_volume_tier",
        type: "several",
        countItems: 3,
        tooltip: "Объем мировых венчурных инвестиций 2026",
        icon: IconDollarQuadro,
        iconActive: IconStarActive,
      },
    ],
  ],
  [
    "weak_signals",
    [
      {
        id: "weak_signal",
        type: "single",
        countItems: 0,
        tooltip: "Слабые сигналы",
        icon: IconWeakSignal,
        iconActive: IconWeakSignalActive,
      },
      {
        id: "weak_signal",
        type: "single",
        countItems: 0,
        tooltip: "Россия/Мир",
        icon: IconWorld,
        iconActive: IconRussiaActive,
      },
    ],
  ],
  [
    "stateInitiative",
    [
      {
        id: "gpb",
        type: "select",
        selectOptions: [
          {label: "Все", value: "all"},
          {label: "Присутствие ГПБ", value: "true"},
          {label: "Без присутствия ГПБ", value: "false"},
        ],
        countItems: 3,
        tooltip: "Присутствие ГПБ",
        icon: LogoIconActive,
        iconActive: LogoIconActive,
      },
      // {
      //   id: "noGpb",
      //   type: "single",
      //   countItems: 0,
      //   tooltip: "Без присутствия ГПБ",
      //   icon: LogoIconActive,
      //   iconActive: LogoIconActive,
      // },
      {
        id: "business_impact",
        type: "several",
        countItems: 3,
        tooltip: "Степень влияния на бизнес",
        icon: IconStar,
        iconActive: IconStarActive,
      },
      {
        id: "lobbying_capability",
        type: "several",
        countItems: 3,
        tooltip: "Возможность лоббирования изменений",
        icon: IconStar,
        iconActive: IconStarActive,
      },
      // ВРЕМЕННО ОТКЛЮЧЕН: фильтр драйверов
      // {
      //   id: "selected_tier",
      //   type: "selectCheckbox",
      //   countItems: 3,
      //   title: "Драйверы",
      //   tooltip: "Приоритетность",
      //   icon: IconStarGray,
      //   iconActive: IconStarActive,
      // },
      {
        id: "live_circle_tier",
        type: "selectCheckbox",
        selectOptions: LIFE_CYCLE_MOCK_DATA,
        countItems: 3,
        title: "Этап жизненного цикла",
        tooltip: "Приоритетность",
        icon: IconStarGray,
        iconActive: IconStarActive,
      },
      {
        id: "influence_zone_tier",
        type: "selectCheckbox",
        selectOptions: INFLUENCE_ZONE_MOCK_DATA,
        countItems: 5,
        title: "Зона влияния",
        tooltip: "Приоритетность",
        icon: IconStarGray,
        iconActive: IconStarActive,
      },
      {
        id: "obligation_level",
        type: "selectCheckbox",
        selectOptions: OBLIGATION_MOCK_DATA,
        countItems: 3,
        title: "Обязательность",
        tooltip: "Уровень обязательности исполнения",
        icon: IconStarGray,
        iconActive: IconStarActive,
      },
      {
        id: "participation_formats",
        type: "selectCheckbox",
        selectOptions: PARTICIPATION_FORMAT_MOCK_DATA,
        countItems: 3,
        title: "Форматы участия компании",
        tooltip: "Приоритетность",
        icon: IconStarGray,
        iconActive: IconStarActive,
      },
      // УБРАН: фильтр "Возможные льготы и субсидии"
      // (реализован отдельным переключателем без звездочки)
      // {
      //   id: "benefits_subsidies",
      //   type: "single",
      //   countItems: 0,
      //   tooltip: "Возможные льготы и субсидии",
      //   icon: IconStarGray,
      //   iconActive: IconStarActive,
      // },
    ],
  ],
]);

// Hide Battery filter (clusters) when feature is disabled
if (!FEATURE_CLUSTER_BATTERY_METRIC_ENABLED) {
  const mapFilters = FILTERS_ITEMS.get("map") || [];
  FILTERS_ITEMS.set(
    "map",
    mapFilters.filter((f) => f.id !== "battery_russia")
  );
}
